import { scroller } from 'react-scroll/modules/index';

/**
 * @param {object} errors
 */
export function scrollerHandler (errors) {
    scroller.scrollTo(Object.keys(errors)[0], { offset: -150, smooth: true });
}



// WEBPACK FOOTER //
// ./src/utils/scrollerHandler.js